// Fires a single analytics event to GA4 (via gtag) and PostHog whenever a
// "Book a Free Assessment" CTA is clicked, tagged with where it was clicked so
// we can see which placement converts best. Safe no-op if a tool isn't loaded.

// Anonymous, cookieless first-party beacon (placement/path/timestamp only, no
// identifiers) so the admin dashboard has data regardless of GA4/PostHog consent.
function beacon(pathname, payload) {
  if (typeof window === 'undefined') return;
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}${pathname}`;
    const body = JSON.stringify(payload);
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([body], { type: 'application/json' }));
    } else {
      fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true }).catch(() => {});
    }
  } catch (e) { /* no-op */ }
}

export function trackAssessmentClick(placement) {
  const props = {
    cta: 'book_free_assessment',
    placement,
    path: typeof window !== 'undefined' ? window.location.pathname : '',
  };

  beacon('/api/events/cta-click', { placement, path: props.path });

  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', 'assessment_cta_click', { ...props, transport_type: 'beacon' });
    }
  } catch (e) { /* no-op */ }

  try {
    if (typeof window !== 'undefined' && window.posthog && typeof window.posthog.capture === 'function') {
      window.posthog.capture('assessment_cta_click', props);
    }
  } catch (e) { /* no-op */ }
}

// Booking + lead-conversion tracking is owned entirely by GTM (its Calendly listener
// fires booking_form_submit -> GA4 booking_complete + the Google Ads conversion). The
// app fires NO booking/conversion events; it only pushes a single non-PII `generate_lead`
// dataLayer event on a successful contact-form submit (see ContactBand.js).

// Records the cookie choice. The decline case can't go to GA4/PostHog (the visitor
// just refused them), so every choice is logged first-party to /api/consent — that
// beacon is what gives you the true opt-in rate. On accept we also fire a GA4/PostHog
// `cookie_consent` event (tools are now loaded) for funnel context.
export function trackConsent(choice) {
  if (typeof window === 'undefined') return;
  const path = window.location.pathname;

  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/consent`;
    const body = JSON.stringify({ choice, path });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([body], { type: 'application/json' }));
    } else {
      fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true }).catch(() => {});
    }
  } catch (e) { /* no-op */ }

  if (choice !== 'accept') return; // decline never touches third-party tools
  const props = { consent_choice: choice, path };
  try {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'cookie_consent', { ...props, transport_type: 'beacon' });
    }
  } catch (e) { /* no-op */ }
  try {
    if (window.posthog && typeof window.posthog.capture === 'function') {
      window.posthog.capture('cookie_consent', props);
    }
  } catch (e) { /* no-op */ }
}
